module.exports = __webpack_public_path__ + "img/plus.b602af3e.svg";